// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';

interface Props {
  /**
   * If true, the dialog is open.
   */
  isOpen: boolean;

  /**
   * A callback fired when the cancel button is clicked.
   */
  onCancel: (() => void) | undefined;

  /**
   * A callback fired when the proceed button is clicked.
   */
  onProceed: (() => void) | undefined;
}

/**
 * A confirmation dialog that prompts the user to confirm if they want to leave
 * without saving changes.
 */
export function UnsavedChangesDialog(props: Props) {
  return (
    <Dialog fullWidth maxWidth="xs" open={props.isOpen}>
      <DialogTitle>Unsaved changes</DialogTitle>
      <DialogContent dividers>
        <Typography>
          You have unsaved changes. Are you sure you want to leave without
          saving?
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={props.onCancel}>No, cancel</Button>
        <Button color="error" onClick={props.onProceed}>
          Yes, leave without saving
        </Button>
      </DialogActions>
    </Dialog>
  );
}
